import React from "react"
import { Tooltip } from "antd"
import "./materialTip.scss"
import cx from "classnames"

export default class MaterialTip extends React.Component {
  render() {
    const { onVisibleChange, title, overlayClassName, placement, ...rest  } = this.props
    let overlayClass = cx({
      "tip-wrapper": true,
      overlayClassName: overlayClassName
    })
    return (
      <Tooltip
        overlayClassName={overlayClass}
        placement={ placement || "bottomLeft" }
        title={title || ""}
        onVisibleChange={onVisibleChange}
        {...rest}
      >
        {this.props.children}
      </Tooltip>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/normal/MaterialTip/MaterialTip.js